import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import {
  IonContent,
  IonPage,
  IonModal,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonButton,
  IonIcon,
  IonLoading,
  useIonToast,
  IonCheckbox,
  IonSkeletonText,
  IonAlert,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonList,
  IonSearchbar,
  IonItem,
  IonLabel,
} from '@ionic/react';
import { MenuItem, Select } from '@material-ui/core';
import { format as ft } from 'date-fns';
import { addCircleOutline, chatbox, checkmarkCircle, clipboard, close, createOutline, locationOutline } from 'ionicons/icons';
import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import SignatureCanvas from 'react-signature-canvas'

import Down from '../../assets/cheveron.svg';
import Signature from '../../assets/icons/signature.png';
import axios from '../../axios';
import Header from '../../components/Header';
import { createMaintenanceFields } from '../../models/createMaintenanceFields';
import { AppContext } from '../../providers/AppContext';
import {
  getAssetComponentName,
  getSetAssetNameWithNoMaintenance,
  getSetComponentType,
  isFormDataEmpty,
} from '../../utils';



const MaintenanceDetail: React.FC = () => {
  const isMounted = useRef(true);

  const { state } = useContext(AppContext);

  const location = useLocation();
  const history = useHistory();
  const [data, setData] = useState<any>({
    name: '',
  });

  const [show1, setShow1] = useState(true);
  const [show2, setShow2] = useState(false);


  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [checked, setChecked] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const [assets, setAssets] = useState<any>([]);
  const [searchText, setSearchText] = useState('');
  const [assetModalToggle, setSetAssetModalToggle] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState();


  const { t } = useTranslation();

  const [present] = useIonToast();

  const [showModal, setShowModal] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const [_data, set_Data] = useState<any>(createMaintenanceFields);
  const [selectedItem, setSelectedItem] = useState('');

  const [shimmer, setShimmer] = useState(false);
  const [chLoader, setChLoader] = useState(false); // Checklist Create Loader
  const [signaturePadShow, setSignaturePadShow] = useState(false);
  const [remarkToggle, setRemarkToggle] = useState(false);
  const [remark, setRemark] = useState<any>('');

  const [streetNameToggle, setStreetNameToggle] = useState(false);
  const [streetName, setStreetName] = useState<any>('');

  const [primaryData, setPrimaryData] = useState<any>({});


  useEffect(() => {
    console.log(location)
    if (history?.location?.state) {
      setShow1(true);
      getAssetIndividual('');
    }

    // Cleanup function
    return () => {
      isMounted.current = false; // Mark the component as unmounted when it's being cleaned up
      // You can also cancel any subscriptions or clean up other resources here
    };
  }, [history.location.state]);


  const getAssetIndividual = async (type: any) => {
    isMounted.current = true; // Set isMounted to true
    const res: any = history.location.state;
    const url = `/resource/Maintenance Request/${res}`;
    const config: any = {
      method: 'get',
      url,
      headers: {
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
    };
    try {
      if (!type) {
        if (isMounted.current)
          setShimmer(true);
      }
      const res = await axios(config);
      if (isMounted.current) {
        setData(res?.data?.data);
        setPrimaryData(res?.data?.data);
      }
      const tempCheckList: any = { ...checked };
      if (res.data.data['maintenance_checklist_details1'].length) {
        const mList = res.data.data['maintenance_checklist_details1'];
        for (const item in mList) {
          let value = false;
          if (mList[item]['yes_or_no'] === 'Sim' || mList[item]['yes_or_no'] === 'Yes') {
            value = true;
          }

          tempCheckList[mList[item]['name']] = value;
        }
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      if (isMounted.current)
        setShimmer(false);
    }
  };

  const handleChange = (event: any) => {
    const formentry: any = [..._data];
    const f_index = formentry.findIndex((v: any) => v.field === event.target.id);
    const change_form_object = formentry[f_index];
    change_form_object.value = event.target.value;
    formentry[f_index] = change_form_object;
    set_Data(formentry);
  };

  const handleSelectChange = (event: any) => {
    const formentry: any = [..._data];

    const select = event.target.name.replaceAll('-', '_');
    const f_index = formentry.findIndex((v: any) => v.field === select);
    if (select === 'maintenance_type') {
      formentry[f_index] = { ...formentry[f_index], value: event.target.value };
      const periodIndex = formentry.findIndex((v: any) => v.field === 'period');
      if (periodIndex !== -1) {
        if (event.target.value === 'Routine') {
          formentry[periodIndex] = { ...formentry[periodIndex], hide: false, required: true };
        } else {
          formentry[periodIndex] = { ...formentry[periodIndex], hide: true, required: false, value: '' };
        }
      }
    } else {
      formentry[f_index] = { ...formentry[f_index], value: event.target.value };
    }
    set_Data(formentry);
  };

  const Submit = async (e: any) => {
    e.preventDefault();
    const formData = new FormData();

    for (const item in _data) {
      const field = _data[item]?.field;
      const value = _data[item]?.value;
      if (_data[item]?.type === 'file' && _data[item]?.src) {
        try {

          const response = await fetch(_data[item]?.src?.toString());
          const blob = await response.blob();

          formData.append(field, new File([blob], `${data.name}-attachment.${_data[item].format}`, {

            type: `image/${_data[item].format}`,
          })
          );
        } catch (e: any) {
          console.log(e)
        }
      }

      else if (_data[item].field === 'asset' && primaryData[field] !== data.asset) {

        formData.append('asset', data.asset);
      } else if (typeof field === 'string' && typeof value === 'string' && value !== '' && value !== undefined && value !== null && value !== 'null' && value !== 'undefined' && value !== 'NaN') {

        if (field && (primaryData[field] !== value)) {
          formData.append(field, value);
        }
      }
    }

    const config: any = {
      headers: {
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
      data: formData,
    };
    const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';
    const urlPart = `/method/preflet_asset.api.update_maintenance_request/${data.name}`;
    const fetchUrl = urlPart.startsWith('http')
      ? urlPart
      : `${baseURL.replace(/\/+$/, '')}/${urlPart.replace(/^\/+/, '')}`;

    if (!isFormDataEmpty(formData)) {
      setShowLoading(true);
      try {
        const response = await fetch(fetchUrl, {
          method: 'PUT',
          headers: config.headers,
          body: formData,
        });

        if (!response.ok && response.status !== 200) {
          throw new Error('Update failed');
        }

        reset();
        getAssetIndividual('');
      } catch (error: any) {

        console.log(error);

        present({
          message: 'Try Again',
          color: 'danger',
          duration: 2000,
        });
      } finally {
        setShowLoading(false);
        setShowModal(false);
      }
    } else {
      setShowModal(false);
    }
  };


  const reset = () => {
    for (const x in _data) {
      if (_data[x].type === 'file') {
        _data[x].src = '';
        _data[x].format = '';
        _data[x].value = '';
      } else
        if (_data[x].type === 'select') {
          _data[x].value = '';
        } else {
          _data[x].value = '';
        }
    }

    // Create Maintenance Asset Name changed back to orignal state for CREATE form
    createMaintenanceFields.map((element: any) => {
      if (element.field === 'asset') {
        element.type = 'select';
        element.disabled = false;
      }
      set_Data(createMaintenanceFields);
    });
    setShowModal(false);
  };

  // const toggleCollapse = (title: any) => {
  //   console.log(title);
  //   var collabsible = { ...show };
  //   console.log(collabsible);
  //   if (title in collabsible) {
  //     
  //     collabsible[title] = !collabsible[title];
  //   } else {
  //     
  //     collabsible[title] = true;
  //   }
  //   setShow(collabsible);
  //   console.log(show);
  //   
  //   return collabsible[title] || false;
  // };

  const toogleCheck = async (event: CustomEvent, item: any) => {
    let tempValue = 'Não';
    if (event.detail.checked) {
      tempValue = 'Sim';
    }

    const tempData = data['maintenance_checklist_details1']
    for (const counter in tempData) {
      if (tempData[counter].name === item) {
        tempData[counter]['yes_or_no'] = tempValue;
      }
    }
    updateCheckBox(tempData);
  };

  const addRemarks = async (item: any, actionType: any) => {
    setSelectedItem(item)
    setRemarkToggle(true);
    setRemark(item);
    if (actionType === 'add') {
      setRemark('');
    } else {

      for (const counter in data['maintenance_checklist_details1']) {

        if (data['maintenance_checklist_details1'][counter].name === item) {

          setRemark(data['maintenance_checklist_details1'][counter]['remarks']);
        }
      }
    }
  }

  const updateRemarkInData = async (value: any) => {
    const tempData = data['maintenance_checklist_details1']
    for (const counter in tempData) {
      if (tempData[counter].name === selectedItem) {
        tempData[counter]['remarks'] = value?.trim();
      }
    }
    updateCheckBox(tempData);
  }

  const addStreetName = async (item: any, actionType: any) => {
    setSelectedItem(item);
    setStreetNameToggle(true);
    setStreetName(item);
    if (actionType === 'add') {
      setStreetName('');
    } else {
      for (const counter in data['maintenance_checklist_details1']) {
        if (data['maintenance_checklist_details1'][counter].name === item) {
          setStreetName(data['maintenance_checklist_details1'][counter]['street_name']);
        }
      }
    }
  }

  const updateStreetNameInData = async (value: any) => {
    const tempData = data['maintenance_checklist_details1']
    for (const counter in tempData) {
      if (tempData[counter].name === selectedItem) {
        tempData[counter]['street_name'] = value?.trim();
      }
    }
    updateCheckBox(tempData);
  }

  const updateCheckBox = async (body: any) => {
    const formData = new FormData();
    formData.append('maintenance_checklist_details1', JSON.stringify(body));

    const config: any = {
      method: 'put',
      url: `/method/preflet_asset.api.update_maintenance_request/${data.name}`,
      headers: {
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
      data: formData,
    };
    try {
      const baseURL = localStorage.getItem('baseUrl') || process.env.REACT_APP_BASE_URL || 'https://admin.hyprism.com/api';
      const urlPart = `/method/preflet_asset.api.update_maintenance_request/${data.name}`;
      const fetchUrl = urlPart.startsWith('http')
        ? urlPart
        : `${baseURL.replace(/\/+$/, '')}/${urlPart.replace(/^\/+/, '')}`;

      const response = await fetch(fetchUrl, {
        method: 'PUT',
        headers: config.headers,
        body: formData,
      });

      if (!response.ok && response.status !== 200) {
        throw new Error('Update failed');
      }

      present({
        message: t('Utils.updatedChecklist'),
        color: 'success',
        duration: 800,
      });
    } catch (error: any) {
      console.log(error);

      present({
        message: 'Something went wrong',
        color: 'danger',
        duration: 2000,
      });
    } finally {
      getAssetIndividual('checklist');
    }
  };

  // const toggleCheckListTitle = async (title: any) => {
  //   var ct = { ...checklist };
  //   if (title in ct) {
  //     
  //     ct[title] = !ct[title];
  //   } else {
  //     
  //     ct[title] = true;
  //   }
  //   setChecklist(ct);
  //   
  //   return ct[title] || false;
  // };

  /* Set EDIT FORM for MAINTENANCE excluding CHECKLIST */
  const setEditForm = async () => {
    setShowModal(true);
    setShowLoading(true);
    const assetOptions = await getSetAssetNameWithNoMaintenance(data.name, '', currentPage); // Filter maintenance done assets
    setAssets(assetOptions);
    const newFields = createMaintenanceFields.map((element: any) => ({ ...element }));

    newFields.forEach((element: any) => {
      if (element.field === 'project') {

        element.value = data[element.field];
        element.type = 'text';
        element.disabled = true;
      } else if (element.field === 'asset') {

        element.value = data[element.field];
        element.options = assetOptions;
      } else if (element.type === 'file') {

        element.value = data[element.field];

      } else if (element.field === 'visit_datetime') {

        element.value = data[element.field] || ft(new Date(), 'yyyy-MM-dd HH:mm:ss')
      } else {

        element.value = data[element.field];
      }

      if (element.field === 'period') {
        if (data.maintenance_type === 'Routine') {
          element.hide = false;
          element.required = true;
        } else {
          element.hide = true;
          element.required = false;
        }
      }
    });
    set_Data(newFields);
    setShowLoading(false);
  };

  async function searchNext($event: CustomEvent<void>) {
    const res = await getSetAssetNameWithNoMaintenance('', searchText, currentPage + 1);
    if (res.length) {

      setAssets([...assets, ...res]);
    }
    setCurrentPage(currentPage + 1);
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  const handleSearch = async (text: string | undefined) => {
    if (text !== undefined) {
      setSearchText(text);
      const res = await getSetAssetNameWithNoMaintenance('', text, 1);
      if (res.length) {
        setAssets(res);
      } else {
        setAssets([])
      }
      setCurrentPage(1);
    }
  }

  const setAssetInValue = (asset: any) => {

    setData({ ...data, asset: asset });
    setSelectedAsset(asset);
  }


  // const submitCheckListTitle = async (value: any, index: any) => {
  //   if (!value[index]) {
  //     present({
  //       message: 'Empty ' + index,
  //       color: 'danger',
  //       duration: 2000,
  //     });
  //   } else {
  //     
  //     data[index] = value[index];
  //     var config: any = {
  //       method: 'put',
  //       url: `/resource/Maintenance Request/${data.name}`,
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Accept: 'application/json',
  //         Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
  //       },
  //       data: data,
  //     };
  //     try {
  //       setSaveC(true);
  //       const res = await axios(config);
  //     } catch (error: any) {
  //       
  //       console.log(error.response.data);
  //       
  //       // const x = error.response.data._server_messages;
  //       present({
  //         message: 'Try Again',
  //         color: 'danger',
  //         duration: 2000,
  //       });
  //     } finally {
  //       setSaveC(false);
  //       getAssetIndividual();
  //     }
  //   }
  // };

  // CREATE NEW CHECKLIST ROW
  // const addCheckListDetail = async (values: any, index: any) => {
  //   if (values.activity && values.remarks) {
  //     var tempData = { ...data };
  //     const temp = {
  //       activity: values.activity,
  //       remarks: values.remarks,
  //       yes_or_no: 'Não',
  //     };
  //     if (index === 'checklist1') {
  //       
  //       tempData['maintenance_checklist_details1'].push(temp);
  //     } else if (index === 'checklist2') {
  //       
  //       tempData['maintenance_checklist_details2'].push(temp);
  //     } else {
  //       
  //       tempData['maintenance_checklist_details3'].push(temp);
  //     }
  //     
  //     var config: any = {
  //       method: 'put',
  //       url: `/resource/Maintenance Request/${data.name}`,
  //       headers: {
  //         'Content-Type': 'application/json',
  //         Accept: 'application/json',
  //         Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
  //       },
  //       data: tempData,
  //     };
  //     try {
  //       setChLoader(true);
  //       const res = await axios(config);
  //       getAssetIndividual();
  //     } catch (error: any) {
  //       
  //       console.log(error.response.data);
  //       
  //       // const x = error.response.data._server_messages;
  //       // console.log(x.slice(18).slice(0, x.slice(18).indexOf('\\')));
  //       present({
  //         message: 'Try Again',
  //         color: 'danger',
  //         duration: 2000,
  //       });
  //     } finally {
  //       setChLoader(false);
  //     }
  //   } else {
  //     present({
  //       message: 'Empty ' + t(`Maintenance.CreateM.${index}`),
  //       color: 'danger',
  //       duration: 2000,
  //     });
  //   }
  // };

  const uploadSignature = () => {
    setSignaturePadShow(true);
  };
  const [canvas, setCanvas] = useState<any>(null);

  const getSignature = () => {

    uploadSign(canvas?.toDataURL())
  }

  const uploadSign = async (base64: any) => {
    const config: any = {
      method: 'put',
      url: `/resource/Maintenance Request/${data.name}`,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Basic ${localStorage.getItem('hyprism_login')}`,
      },
      data: {
        sign: base64
      },
    };
    setChLoader(true);
    try {
      await axios(config);
      setSignaturePadShow(false)
      getAssetIndividual('');
      present({
        message: 'Signature Uploaded',
        color: 'success',
        duration: 2000,
      });
    } catch (error: any) {

      console.log(error?.response?.data);

      present({
        message: 'Try Again',
        color: 'danger',
        duration: 2000,
      });
    } finally {
      setChLoader(false);
    }
  };
  const Shimmer = () => {
    return (
      <div>
        {
          [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14].map((element) => {
            return (
              <div
                key={element}
                id="shimmer-body"
                style={{ padding: '1rem' }}
                className="w-50 data-list shimmer-container"
              >
                <div className="flex justify-between">
                  <IonSkeletonText animated style={{ width: '50%' }} />
                  <IonSkeletonText animated style={{ width: '20%' }} />
                </div>
              </div>
            );
          })
        }
      </div>
    );
  };

  const takeQSPicture = async (field: any) => {
    try {
      const image = await Camera.getPhoto({
        quality: 70,
        allowEditing: true,
        resultType: CameraResultType.Uri,
        source: CameraSource.Camera,
      });
      const imageUrl = image.webPath;

      // Can be set to the src of an image now
      const formentry: any = [..._data];
      const f_index = formentry.findIndex((v: any) => v.field === field);
      formentry[f_index].value = null;
      formentry[f_index].src = imageUrl;
      formentry[f_index].format = image.format;
      set_Data(formentry);
    } catch (e: any) {

      console.log('Error: ', e);

      if (e?.toString()?.includes('cancelled')) {

        present({
          message: t('Utils.cameraCancel'),
          color: 'danger',
          duration: 2000,
        });
      }

      else if (e?.toString()?.includes('denied') || e?.includes('access')) {

        present({
          message: t('Utils.cameraErrorPermission'),
          color: 'danger',
          duration: 2000,
        });
      } else {

        present({
          message: e,
          color: 'danger',
          duration: 2000,
        });
      }
    }
  };

  /* Remove Quick Status Image by cross click */
  const emptyQSImg = (field: any) => {
    const formentry: any = [..._data];
    const f_index = formentry.findIndex((v: any) => v.field === field);
    formentry[f_index].value = null;
    formentry[f_index].src = null;
    formentry[f_index].format = null;
    set_Data(formentry);
  };

  return (
    <IonPage>
      <Header enableBackButton={location.search ? 'goBack' : '/maintenanceHistory'} title={t('Maintenance.Detail.Det')} />
      <IonLoading

        isOpen={chLoader}
        onDidDismiss={() => setChLoader(false)}
        message={'Please wait...'}
      />
      <IonModal isOpen={showModal} onDidDismiss={() => setShowModal(false)}>
        <IonLoading

          isOpen={showLoading}
          onDidDismiss={() => setShowLoading(false)}
          message={'Please wait...'}
          duration={5000}
        />
        <IonHeader>
          <IonToolbar color="primary">
            <IonTitle>
              {t(`Assets.CreateA.edit`)} {data.name}
            </IonTitle>
            <IonButtons slot="end">
              <IonButton
                onClick={() => {
                  reset();
                }}
              >
                <IonIcon icon={close} slot="icon-only"></IonIcon>
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
          <form onSubmit={(e) => Submit(e)}>
            {_data.map((form_field: any, index: any) => {
              if (form_field.field === 'period' && form_field.hide) {
                return null;
              }

              //  Exluding Checklist in this FORM

              if (!form_field.name) {
                if (form_field.title && form_field.title !== 'Maintenance.Detail.AC') {
                  return (
                    <p className="form-title" key={`${form_field.title}-${index}`}>
                      {t(form_field.title)}
                    </p>
                  );
                } else if (form_field.type === 'text') {
                  return (
                    <div className="input-container" key={`${form_field.field}`}>
                      <label className="label">
                        {t(form_field.label)}
                        {form_field.required ? '*' : null}
                      </label>
                      <input
                        required={form_field.required}
                        className="basic-input"
                        key={`${form_field.field}-${index}`}
                        id={form_field.field}
                        placeholder={t(form_field.label)}
                        onChange={handleChange}
                        value={form_field.value}
                        disabled={form_field.disabled}
                        style={{
                          background: form_field.disabled ? '#F1F7F5' : ''
                        }}
                      />
                    </div>
                  );
                } else if (form_field.type === 'number') {
                  return (
                    <div className="input-container" key={`${form_field.field}`}>
                      <label className="label">
                        {t(form_field.label)}
                        {form_field.required ? '*' : null}
                      </label>
                      <input
                        type="number"
                        step="any"
                        required={form_field.required}
                        className="basic-input"
                        key={`${form_field.field}-${index}`}
                        id={form_field.field}
                        placeholder={t(form_field.label)}
                        onChange={handleChange}
                        value={form_field.value}
                        disabled={form_field.disabled}
                        style={{
                          background: form_field.disabled ? '#F1F7F5' : ''
                        }}
                      />
                    </div>
                  );
                } else if (form_field.type === 'textarea') {
                  return (
                    <div className="input-container" key={`${form_field.field}`} style={{ width: '100%', gridColumn: '1 / -1' }}>
                      <label className="label">
                        {t(form_field.label)}
                        {form_field.required ? '*' : null}
                      </label>

                      <textarea
                        className="textarea"
                        required={form_field.required}
                        key={`${form_field.field}-${index}`}
                        id={form_field.field}
                        style={{ marginTop: '0.5rem', width: '100%', background: form_field.disabled ? '#F1F7F5' : '' }}
                        placeholder={t(form_field.label)}
                        onChange={handleChange}
                        value={form_field.value}
                        disabled={form_field.disabled}
                      />
                    </div>
                  );
                } else if (form_field.field === 'asset') {
                  return (
                    <div className="input-container" key={`${form_field.field}-${index}`}>
                      <label className="label">
                        {t(form_field.label)}
                        {form_field.required ? '*' : null}
                      </label>
                      <p onClick={() => setSetAssetModalToggle(!assetModalToggle)} className='basic-input' style={{ marginTop: '0px' }}>{

                        data['asset'] || <span style={{ color: 'gray' }}>{t('Utils.selectAsset')}</span>}</p>
                    </div>)
                }
                else if (form_field.type === 'select') {
                  return (
                    <div className="input-container" key={`${form_field.field}`}>
                      <label className="label">
                        {t(form_field.label)}
                        {form_field.required ? '*' : null}
                      </label>

                      <Select
                        className="custom-select"
                        required={form_field.required}
                        id={`${form_field.field}_choice`}
                        name={form_field.field}
                        onChange={handleSelectChange}
                        value={form_field.value}
                        disabled={form_field.disabled || false}
                        key={`${form_field.field}-${index}`}
                      >
                        {form_field.options?.map(function (opt: any, optIndex: any) {
                          return (
                            <MenuItem value={`${opt}`} key={`${opt}-${optIndex}`} id={`${opt}_item_${optIndex}`}>
                              <section style={{ display: 'flex', height: '1rem' }}>
                                <p
                                  style={{
                                    color: 'rgba(31, 87, 148, 1)',
                                    marginLeft: '0.2rem',
                                    fontSize: '12px',
                                    marginTop: '0px',
                                  }}
                                >
                                  {t(opt)}
                                </p>
                              </section>
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </div>
                  );
                }
                else if (form_field.type === 'file') {
                  const hasExisting = !!form_field['value'];
                  const hasNew = !!form_field['src'];
                  const existingSrc = hasExisting
                    ? `${localStorage.getItem('baseUrl')?.replace('/api', '')}${form_field['value']}`
                    : null;
                  const previewSrc = hasNew ? form_field['src'] : existingSrc;

                  return (
                    <div
                      id={`${form_field.field}-${index}`}
                      key={`${form_field.field}-${index}`}
                      style={{ marginBottom: '12px' }}
                    >
                      <label id={`label-${form_field.field}`} className="label" style={{ marginBottom: '8px', display: 'block' }}>
                        {t(form_field.label)}
                        {form_field.required ? '*' : null}
                      </label>
                      <div
                        onClick={() => takeQSPicture(form_field.field)}
                        style={{
                          border: previewSrc ? '2px solid #1F5794' : '2px dashed #b0c4de',
                          borderRadius: '14px',
                          padding: previewSrc ? '0' : '20px 12px',
                          cursor: 'pointer',
                          background: previewSrc ? 'transparent' : '#f4f8fe',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          minHeight: previewSrc ? 'auto' : '90px',
                          position: 'relative',
                          overflow: 'hidden',
                        }}
                      >
                        {previewSrc ? (
                          <>
                            <img
                              src={previewSrc}
                              alt=""
                              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNhMGEwYTAiIHN0cm9rZS13aWR0aD0iMiIgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMiIgcnk9IjIiPjwvcmVjdD48Y2lyY2xlIGN4PSI4LjUiIGN5PSI4LjUiIHI9IjEuNSI+PC9jaXJjbGU+PHBhdGggZD0iTTIxIDE1bC01LTUtNCA0LTEtMS01IDUiPjwvcGF0aD48bGluZSB4MT0iMyIgeTE9IjMiIHgyPSIyMSIgeTI9IjIxIj48L2xpbmU+PC9zdmc+'; e.currentTarget.style.objectFit = 'contain'; e.currentTarget.style.padding = '2rem'; e.currentTarget.style.background = '#f5f5f5'; }}
                              style={{ width: '100%', borderRadius: '12px', display: 'block', maxHeight: '180px', objectFit: 'cover' }}
                            />
                            <div style={{
                              position: 'absolute', bottom: 0, left: 0, right: 0,
                              background: 'rgba(0,0,0,0.45)', padding: '6px 12px',
                              display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            }}>
                              <span style={{ color: 'white', fontSize: '12px', fontWeight: 600 }}>✎ {t('Utils.change_image')}</span>
                              {hasNew && (
                                <span
                                  onClick={(e) => { e.stopPropagation(); emptyQSImg(form_field.field); }}
                                  style={{ color: '#ff6b6b', fontSize: '20px', fontWeight: 700, lineHeight: 1, cursor: 'pointer' }}
                                >×</span>
                              )}
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={{ fontSize: '28px', marginBottom: '6px', color: '#7aa7d8' }}>📷</div>
                            <p style={{ margin: 0, fontSize: '13px', color: '#7aa7d8', fontWeight: 600 }}>{t('Utils.image')}</p>
                            <p style={{ margin: '2px 0 0', fontSize: '10px', color: '#aac4e0' }}>Tap to upload</p>
                          </>
                        )}
                      </div>
                    </div>
                  );
                }
                else if (form_field.type === 'date' || form_field.type === 'datetime-local') {
                  return (
                    <div className="input-container" key={`${form_field.field}-${index}`}>
                      <label className="label">
                        {t(form_field.label)}
                        {form_field.required ? '*' : null}
                      </label>

                      <input
                        required={form_field.required}
                        className="date"
                        key={`${form_field.field}-${index}`}
                        id={form_field.field}
                        placeholder={t(form_field.label)}
                        onChange={handleChange}
                        value={form_field.value}
                        type={form_field.type}
                        disabled={form_field.disabled}
                        style={{
                          background: form_field.disabled ? '#F1F7F5' : ''
                        }}
                      />
                    </div>
                  );
                } else {
                  return '';
                }
              }
            })}
            <button className="submit-button" type="submit">
              {t(`Service.ServiceCreate.save`)}{' '}
            </button>
          </form>
        </IonContent>
      </IonModal>
      <IonModal
        isOpen={assetModalToggle}
        onDidDismiss={() => setSetAssetModalToggle(false)}
      ><IonHeader>
          <IonToolbar>
            <IonTitle>Assets</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setSetAssetModalToggle(false)}>Close</IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonSearchbar
            className="data-list"
            value={searchText}

            onIonChange={(e) => handleSearch(e.detail.value)}
          ></IonSearchbar>
          {shimmer && <Shimmer />}
          <IonList>
            {assets?.length ? assets.map((asset: any, index: any) => (
              <IonItem
                key={index}
                onClick={() => {
                  setSetAssetModalToggle(false);
                  setAssetInValue(asset)
                }}
              >
                <IonLabel>{asset}</IonLabel>
                <IonCheckbox
                  slot="end"
                  value={asset}
                  checked={asset === selectedAsset} />
              </IonItem>
            )) :
              <div style={{ margin: 'auto', display: 'block' }}>
                <p className='text-center' style={{ color: 'gray' }}>No Asset found</p>
              </div>}
          </IonList>

          <IonInfiniteScroll onIonInfinite={(e: CustomEvent<void>) => searchNext(e)}>
            <IonInfiniteScrollContent
              loadingSpinner="bubbles"
              loadingText="Loading more data..."
            ></IonInfiniteScrollContent>
          </IonInfiniteScroll>
        </IonContent>
      </IonModal>
      <IonContent>
        {/* ── Hero Banner ── */}
        <div style={{
          background: 'linear-gradient(135deg, #1d508d 0%, #2a6db5 100%)',
          padding: '1.4rem 1.2rem 1rem',
          color: '#fff',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{ margin: 0, fontSize: '11px', opacity: 0.75, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                {t('Maintenance.Detail.Det')}
              </p>
              <h2 style={{ margin: '4px 0 8px', fontSize: '20px', fontWeight: 700, wordBreak: 'break-word' }}>
                {data.name || '—'}
              </h2>
              {data.maintenance_type && (
                <span style={{
                  display: 'inline-block',
                  background: 'rgba(255,255,255,0.18)',
                  borderRadius: '20px',
                  padding: '3px 12px',
                  fontSize: '12px',
                  fontWeight: 600,
                  marginBottom: '4px',
                }}>
                  {data.maintenance_type}
                </span>
              )}
            </div>
            {/* Signature button */}
            <div style={{ marginLeft: '12px', flexShrink: 0, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {data['sign'] ? (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <img src={Signature} alt='sign' style={{ width: '28px', filter: 'invert(1)', opacity: 0.85 }} />
                  <IonIcon src={checkmarkCircle} style={{ color: '#4cff8a', fontSize: '16px', marginTop: '-6px' }} />
                </div>
              ) : (
                !!state.permissions.maintenance_request_update && (
                  <div
                    onClick={() => uploadSignature()}
                    style={{
                      background: 'rgba(255,255,255,0.15)',
                      borderRadius: '50%',
                      padding: '8px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <img src={Signature} alt='sign' style={{ width: '22px', filter: 'invert(1)' }} />
                  </div>
                )
              )}
            </div>
          </div>
        </div>

        {/* ── Details Card ── */}
        <div style={{ margin: '14px 12px 0' }}>
          {/* Card header */}
          <div
            onClick={() => setShow1(!show1)}
            style={{
              background: 'linear-gradient(90deg, #1d508d 0%, #2a6db5 100%)',
              borderRadius: show1 ? '12px 12px 0 0' : '12px',
              padding: '12px 16px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              cursor: 'pointer',
            }}
          >
            <span style={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>{t('Utils.basicD')}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              {!!state.permissions.maintenance_request_update && show1 && (
                <IonIcon
                  onClick={(e) => { e.stopPropagation(); setEditForm(); }}
                  src={createOutline}
                  style={{ color: '#fff', fontSize: '20px', cursor: 'pointer' }}
                />
              )}
              <img
                src={Down}
                alt="chevron"
                style={{ width: '16px', color: '#fff', transition: 'transform 0.25s', transform: show1 ? 'rotate(180deg)' : 'rotate(0deg)' }}
              />
            </div>
          </div>

          {/* Card body */}
          {show1 && (
            <div style={{
              background: '#fff',
              borderRadius: '0 0 12px 12px',
              boxShadow: '0 4px 18px rgba(0,0,0,0.08)',
              overflow: 'hidden',
              marginBottom: '14px',
            }}>
              {createMaintenanceFields.map((item: any, index) => {
                if (!item.field || item.name) return null;

                if (item.type === 'file') {
                  if (!data[item.field]) return null;
                  const imgSrc = `${localStorage.getItem('baseUrl')?.replace('/api', '')}${data[item.field]}`;
                  return (
                    <div key={`detail-file-${index}`} style={{ padding: '12px 16px', borderTop: index > 0 ? '1px solid #f0f0f0' : 'none' }}>
                      <p style={{ margin: '0 0 8px', fontSize: '11px', fontWeight: 700, color: '#6b7b8f', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                        {t(`Maintenance.CreateM.${item.field}`)}
                      </p>
                      <div style={{ position: 'relative', borderRadius: '10px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', cursor: 'pointer' }}
                        onClick={() => window.open(imgSrc, '_blank')}>
                        <img
                          src={imgSrc}
                          alt={t(`Maintenance.CreateM.${item.field}`)}
                          onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNhMGEwYTAiIHN0cm9rZS13aWR0aD0iMiIgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMiIgcnk9IjIiPjwvcmVjdD48Y2lyY2xlIGN4PSI4LjUiIGN5PSI4LjUiIHI9IjEuNSI+PC9jaXJjbGU+PHBhdGggZD0iTTIxIDE1bC01LTUtNCA0LTEtMS01IDUiPjwvcGF0aD48bGluZSB4MT0iMyIgeTE9IjMiIHgyPSIyMSIgeTI9IjIxIj48L2xpbmU+PC9zdmc+'; e.currentTarget.style.objectFit = 'contain'; e.currentTarget.style.padding = '2rem'; }}
                          style={{ width: '100%', maxHeight: '200px', objectFit: 'cover', display: 'block', background: '#f5f5f5' }}
                        />
                        <div style={{
                          position: 'absolute', bottom: 0, left: 0, right: 0,
                          background: 'linear-gradient(transparent, rgba(0,0,0,0.45))',
                          padding: '6px 10px',
                        }}>
                          <span style={{ fontSize: '11px', color: 'rgba(255,255,255,0.9)' }}>Tap to open</span>
                        </div>
                      </div>
                    </div>
                  );
                }

                const rawVal = typeof data[item.field] === 'object' ? data[item.field]?.[0]?.activity : data[item.field];
                if (!rawVal) return null;

                return (
                  <div key={`detail-${index}`} style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    padding: '11px 16px',
                    borderTop: index > 0 ? '1px solid #f0f4f8' : 'none',
                    gap: '8px',
                  }}>
                    <span style={{ fontSize: '13px', color: '#6b7b8f', fontWeight: 500, flex: '0 0 42%', wordBreak: 'break-word' }}>
                      {t(`Maintenance.CreateM.${item.field}`)}
                    </span>
                    <span style={{ fontSize: '13px', color: '#1a2a3a', fontWeight: 600, flex: '0 0 54%', textAlign: 'right', wordBreak: 'break-word' }}>
                      {rawVal}
                    </span>
                  </div>
                );
              })}

              {/* Signature row */}
              {data.sign && (
                <div style={{ padding: '12px 16px', borderTop: '1px solid #f0f4f8' }}>
                  <p style={{ margin: '0 0 8px', fontSize: '11px', fontWeight: 700, color: '#6b7b8f', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                    {t('Maintenance.CreateM.sign')}
                  </p>
                  <img
                    src={data['sign']}
                    alt='sign'
                    onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNhMGEwYTAiIHN0cm9rZS13aWR0aD0iMiIgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHJlY3QgeD0iMyIgeT0iMyIgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiByeD0iMiIgcnk9IjIiPjwvcmVjdD48Y2lyY2xlIGN4PSI4LjUiIGN5PSI4LjUiIHI9IjEuNSI+PC9jaXJjbGU+PHBhdGggZD0iTTIxIDE1bC01LTUtNCA0LTEtMS01IDUiPjwvcGF0aD48bGluZSB4MT0iMyIgeTE9IjMiIHgyPSIyMSIgeTI9IjIxIj48L2xpbmU+PC9zdmc+'; e.currentTarget.style.objectFit = 'contain'; e.currentTarget.style.padding = '1rem'; }}
                    style={{ border: '1px solid #e5eaf0', borderRadius: '10px', maxWidth: '200px', margin: '0 auto', display: 'block', background: '#f9fbff' }}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {/* ── Checklist Card ── */}
        {!shimmer && data?.maintenance_checklist_details1?.length > 0 && (
          <div style={{ margin: '0 12px 20px', marginTop: '1rem' }}>
            {/* Card header */}
            <div
              onClick={() => setShow2(!show2)}
              style={{
                background: 'linear-gradient(90deg, #1d508d 0%, #2a6db5 100%)',
                borderRadius: show2 ? '12px 12px 0 0' : '12px',
                padding: '12px 16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <span style={{ color: '#fff', fontWeight: 700, fontSize: '14px' }}>{t('Utils.checkList')}</span>
              <img
                src={Down}
                alt="chevron"
                style={{ width: '16px', color: '#fff', transition: 'transform 0.25s', transform: show2 ? 'rotate(180deg)' : 'rotate(0deg)' }}
              />
            </div>

            {show2 && (
              <div style={{ background: '#fff', borderRadius: '0 0 12px 12px', boxShadow: '0 4px 18px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
                {data.maintenance_checklist_details1.map((item: any, index: any) => {
                  const isChecked = item.yes_or_no === 'Sim' || item.yes_or_no === 'Yes';
                  return (
                    <div
                      key={`checklist-${index}`}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        justifyContent: 'space-between',
                        padding: '12px 16px',
                        borderTop: index > 0 ? '1px solid #f0f4f8' : 'none',
                        gap: '10px',
                      }}
                    >
                      {/* Left: activity + meta */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                          <IonIcon src={clipboard} style={{ color: '#1d508d', fontSize: '16px', flexShrink: 0 }} />
                          <span style={{ fontSize: '14px', fontWeight: 600, color: '#1a2a40', wordBreak: 'break-word' }}>
                            {item.activity}
                          </span>
                        </div>

                        {/* Remarks */}
                        {item.remarks ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '4px' }}>
                            <IonIcon src={chatbox} style={{ color: '#6b7b8f', fontSize: '13px' }} />
                            <span style={{ fontSize: '12px', color: '#6b7b8f', flex: 1, wordBreak: 'break-word' }}>{item.remarks}</span>
                            <span
                              onClick={() => addRemarks(item.name, 'edit')}
                              style={{ fontSize: '11px', color: '#1d508d', fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}
                            >{t('Utils.edit')}</span>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '4px' }}>
                            <span style={{ fontSize: '12px', color: '#aab0ba', marginRight: '4px' }}>{t('Utils.remarks')}</span>
                            <IonIcon
                              onClick={() => addRemarks(item.name, 'add')}
                              src={addCircleOutline}
                              style={{ color: '#1d508d', fontSize: '18px', cursor: 'pointer' }}
                            />
                          </div>
                        )}

                        {/* Street name / location */}
                        {item.street_name ? (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '4px' }}>
                            <IonIcon src={locationOutline} style={{ color: '#6b7b8f', fontSize: '13px' }} />
                            <span style={{ fontSize: '12px', color: '#6b7b8f', flex: 1, wordBreak: 'break-word' }}>{item.street_name}</span>
                            <span
                              onClick={() => addStreetName(item.name, 'edit')}
                              style={{ fontSize: '11px', color: '#1d508d', fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}
                            >{t('Utils.edit')}</span>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '4px' }}>
                            <span style={{ fontSize: '12px', color: '#aab0ba', marginRight: '4px' }}>{t('Maintenance.CreateM.street_name')}</span>
                            <IonIcon
                              onClick={() => addStreetName(item.name, 'add')}
                              src={addCircleOutline}
                              style={{ color: '#1d508d', fontSize: '18px', cursor: 'pointer' }}
                            />
                          </div>
                        )}
                      </div>

                      {/* Right: checkbox */}
                      <div style={{ flexShrink: 0, paddingTop: '2px' }}>
                        <IonCheckbox
                          color="danger"
                          id={item.name}
                          checked={isChecked}
                          onIonChange={(event) => toogleCheck(event, item.name)}
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ── Signature Pad Modal ── */}
        <IonModal isOpen={signaturePadShow}>
          <IonHeader>
            <IonToolbar>
              <IonTitle>Signature Pad</IonTitle>
              <IonButtons slot="end">
                <IonButton onClick={() => setSignaturePadShow(false)}>{t('Utils.close')}</IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <div style={{ marginTop: '2rem', border: '1px solid lightgray', margin: '5px', borderRadius: '5px' }}>
            <SignatureCanvas penColor='#1d508d'
              backgroundColor='rgba(255, 255, 255, 0)'
              ref={(ref: any) => { setCanvas(ref) }}
              dotSize={5}
              canvasProps={{ width: 500, height: 400, className: 'sigCanvas' }} />
          </div>
          <button className="submit-button" onClick={() => getSignature()}>
            {t(`Utils.addSignautre`)}
          </button>
        </IonModal>
      </IonContent>
      <IonAlert
        isOpen={remarkToggle}
        onDidDismiss={() => setRemarkToggle(false)}
        header="Enter Remark"
        inputs={[
          {
            type: 'textarea',
            placeholder: 'Add remark',
            value: remark,
          },
        ]}
        buttons={[
          {
            text: t('Utils.add'),
            handler: (event) => {
              updateRemarkInData(event[0]);
              setRemarkToggle(false);
            },
          },
        ]}
      ></IonAlert>
      <IonAlert
        isOpen={streetNameToggle}
        onDidDismiss={() => setStreetNameToggle(false)}
        header={t('Maintenance.CreateM.street_name')}
        inputs={[
          {
            type: 'textarea',
            placeholder: `Add ${t('Maintenance.CreateM.street_name')}`,
            value: streetName,
          },
        ]}
        buttons={[
          {
            text: t('Utils.add'),
            handler: (event) => {
              updateStreetNameInData(event[0]);
              setStreetNameToggle(false);
            },
          },
        ]}
      ></IonAlert>
    </IonPage>
  );
};

export default MaintenanceDetail;
